import { Call } from "@/entities/call";
import { httpByCurrentCustomer } from "@/lib/client";

export function getCallsParameterized(
  request: CallRequestInfo
): Promise<Call[]> {
  return httpByCurrentCustomer().post(`calls`, { json: request }).json();
}

export type CallRequestInfo = {
  start: string;
  end: string;
  phone: string;
  /**
   * Formato simbolovalor ejemplo >50, <100 =800
   */
  duration: string;
  /**
   * Array de etiquetas con el siguiente formato clave:valor ejemplo: centro:32
   */
  tags: string[];
  center: number;
};
